import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { cadastrarCliente, getChavePublica } from '../../services/api';
// css
import 'bootstrap/dist/css/bootstrap.min.css';
import "./FormCadastrarCliente.css";
import '../../styles/global.css';


const FormCadastrarCliente = () => {
  
  const navigate = useNavigate();  // Hook para navegação

  const [formData, setFormData] = useState({
    
    numeroCartao: "",
    mesValidadeCartao: "",
    anoValidadeCartao: "",
    nomeComoEstaNoCartao: "",
    codigoCartao: "",
    cartaoCriptografadoPagbank: "",
    
    observacao: "",
    
    nomeCompleto: "",
    cpf: "",
    telefoneCelular: "",
    nomeCompleto: "",
    email: "",

    password: "",
    confirmPassword: "",

  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  /**
   * Método que criptografa o cartão
   */
  const handleEncryptCard = async (chavePublica) => {
    console.log('Entrou em handleEncryptCard...');
    if (!window.PagSeguro) {
      alert('SDK do PagSeguro ainda não foi carregada!');
      return;
    }
  
    const card = window.PagSeguro.encryptCard({
      // publicKey: chavePublica,
      publicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr+ZqgD892U9/HXsa7XqBZUayPquAfh9xx4iwUbTSUAvTlmiXFQNTp0Bvt/5vK2FhMj39qSv1zi2OuBjvW38q1E374nzx6NNBL5JosV0+SDINTlCG0cmigHuBOyWzYmjgca+mtQu4WczCaApNaSuVqgb8u7Bd9GCOL4YJotvV5+81frlSwQXralhwRzGhj/A57CGPgGKiuPT+AOGmykIGEZsSD9RKkyoKIoc0OS8CPIzdBOtTQCIwrLn2FxI83Clcg55W8gkFSOS6rWNbG5qFZWMll6yl02HtunalHmUlRUL66YeGXdMDC2PuRcmZbGO5a/2tbVppW6mfSWG3NPRpgwIDAQAB',
      holder: formData.nomeComoEstaNoCartao,
      number: formData.numeroCartao,
      expMonth: formData.mesValidadeCartao,
      expYear: formData.anoValidadeCartao,
      securityCode: formData.codigoCartao,
    });
  
    if (card.hasErrors) {
      console.error('Erros na criptografia do cartão:', card.errors);
      alert('Erro nos dados do cartão.');
      return;
    }

    // vamos apagar o código do cartão do cliente, para não passarmos pro back
    setFormData({ ...formData, codigoCartao: "" });

    const cartaoCriptografado = card.encryptedCard;
 
    console.log('Cartão criptografado (em handleEncryptCard...):');
    console.log(cartaoCriptografado);
    console.log('Tamanho do cartão criptografado:');
    console.log(cartaoCriptografado ? cartaoCriptografado.length : null);


    // encryptedCard = encodeURIComponent(card.encryptedCard);

    return card.encryptedCard;

  };
  


  const handleSubmit = async (e) => {
    console.log('entrou no handleSubmit...');
    e.preventDefault();

    /**
     * Precisaremos buscar a chave pública para criptografarmos o cartão
     */
    let chavePublica = null;

    // vamos verificar se a SDK do pagseguro já foi carregada
    console.log('Verificando se a sdk do pagseguro foi carregada...');
    if (!window.PagSeguro) {
      alert('SDK do PagSeguro ainda não foi carregada!');
      return;
    }
    console.log('ok, sdk carregada!');

    console.log('Vamos buscar a chave pública....');

    // Aqui quer dizer que a sdk do pagseguro foi carregada
    try {
      const responseChavePublica = await getChavePublica();
      console.log('Response da have pública recebida:', responseChavePublica);
      chavePublica = responseChavePublica.chavePublica;

      console.log('chave pública: ');
      console.log(chavePublica);

    } catch (error) {
      console.error('Erro ao receber a chave pública:', error);
      // Exibe a mensagem de erro vinda da API
      const errorMessage = error.response?.data?.message || 'Erro ao receber a chave pública.';
      alert(errorMessage);
    }

    /**
     * Agora com a chave pública em mãos, vamos criptografar o cartão
     */
    const cartaoCriptografado = await handleEncryptCard(chavePublica);
    setFormData({ ...formData, codigoCartao: "" });
    /**
     * vamos usar um formDataAtualizado, pois não dá pra atualizar o formData em tempo de execução,
     * por ele ser assíncrono
     */
    const formDataAtualizado = { ...formData, codigoCartao: "" };

    console.log('cartão criptgrafado em handleSubmit....');
    console.log(cartaoCriptografado);

    /**
     * Com o cartão criptografado, vamos cadastrar o cliente
     */
    try {
      const responseCadastrarCliente = await cadastrarCliente(formDataAtualizado, cartaoCriptografado);
      console.log('Cliente cadastrado com sucesso:', responseCadastrarCliente);
      alert('Cliente cadastrado com sucesso!');
      navigate('/');
    } catch (error) {
      console.error('Erro ao cadastrar o cliente:', error);
      // Exibe a mensagem de erro vinda da API
      const errorMessage = error.response?.data?.message || 'Erro ao cadastrar cliente. Tente novamente.';
      alert(errorMessage);
    }
  };

  return (
    <div className="form-cadastrar-container">
        <TituloComponent />

      <form onSubmit={handleSubmit}>
        <h2 className="form-title">Cadastro de Cliente</h2>

        {/* Quadro de Dados Pessoais */}
        <div className="form-section">
          <h3 className="section-title">Dados Pessoais</h3>
          
          <div className="form-group">
            <label htmlFor="nomeCompleto">Nome completo</label>
            <input
              type="text"
              id="nomeCompleto"
              name="nomeCompleto"
              className="form-control"
              placeholder="Digite o nome completo"
              value={formData.nomeCompleto}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="cpf">CPF</label>
            <input
                type="tel" // Altera para 'tel' para exibir teclado numérico
                id="cpf"
                name="cpf"
                className="form-control"
                placeholder="Digite o CPF"
                value={formData.cpf}
                onChange={handleChange}
                // pattern="\d*" // Permite apenas dígitos
                maxLength="14" // Limita o número de caracteres a 11 (tamanho de um CPF sem formatação)
                required
            />
            </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-control"
              placeholder="Digite o email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="telefoneCelular">Telefone Celular com DDD</label>
            <input
              type="tel"
              id="telefoneCelular"
              name="telefoneCelular"
              className="form-control"
              placeholder="Digite o telefone celular"
              value={formData.telefoneCelular}
              onChange={handleChange}
              required
            />
          </div>          

        </div>

        {/* Quadro de Dados do Estabelecimento */}
        <div className="form-section ">

        <h3 className="section-title">Dados de login</h3>

          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
                type="password"
                id="password"
                name="password"
                className="form-control"
                placeholder="Digite sua senha"
                value={formData.password}
                onChange={handleChange}
                required
            />
          </div>  

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirme sua senha</label>
            <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                className="form-control"
                placeholder="Repita sua senha"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
            />
          </div>
        
        </div>

        {/* Quadro de Dados do Estabelecimento */}
        <div className="form-section ">
          <h3 className="section-title">Dados do Cartão</h3>

          <div className="form-group">
            <label htmlFor="nomeComoEstaNoCartao">Nome como está no cartão</label>
            <input
              type="text"
              id="nomeComoEstaNoCartao"
              name="nomeComoEstaNoCartao"
              className="form-control"
              placeholder="Digite seu nome como está no cartão"
              value={formData.nomeComoEstaNoCartao}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="numeroCartao">Número do cartão</label>
            <input
              type="tel"
              id="numeroCartao"
              name="numeroCartao"
              className="form-control"
              placeholder="Num do cartão"
              value={formData.numeroCartao}
              onChange={handleChange}
              required
            />
          </div>
          {/* <div className="form-group">
            <label htmlFor="numeroCartao">Número do cartão</label>
            <input
              type="tel"
              id="numeroCartao"
              name="numeroCartao"
              className="form-control"
              placeholder="Digite o numero do cartao"
              value={formData.numeroCartao}
              onChange={handleChange}
              required
            />
          </div> */}
          <div className="form-group">
            <label htmlFor="mesValidadeCartao">Mês de validade do cartão</label>
            <select
              id="mesValidadeCartao"
              name="mesValidadeCartao"
              className="form-control"
              value={formData.mesValidadeCartao}
              onChange={handleChange}
              required
            >
              <option value="">Selecione o mês</option>
              {[
                "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"
              ].map((mes) => (
                <option key={mes} value={mes}>
                  {mes}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="anoValidadeCartao">Ano de validade do cartão</label>
            <select
              id="anoValidadeCartao"
              name="anoValidadeCartao"
              className="form-control"
              value={formData.anoValidadeCartao}
              onChange={handleChange}
              required
            >
              <option value="">Selecione o ano</option>
              {[
                "2025", "2026", "2027", "2028", "2029", "2030", "2031", "2032", "2033", 
                "2034", "2035", "2036", "2037", "2038", "2039", "2040", "2041", "2042", 
                "2043", "2044", "2045"
              ].map((mes) => (
                <option key={mes} value={mes}>
                  {mes}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="codigoCartao">Código CVV do cartão</label>
            <input
              type="tel"
              id="codigoCartao"
              name="codigoCartao"
              className="form-control"
              placeholder="Digite o código CVV do cartão"
              value={formData.codigoCartao}
              onChange={handleChange}
              required
            />
          </div>          

        </div>

        <button type="submit" className="btn-primary">
          Cadastrar
        </button>
      </form>
    </div>
  );
};

export default FormCadastrarCliente;
